import React, { useState, useContext } from 'react';

import InputField from '@components/common/InputField';
import InputPasswordWithStrength from './InputPasswordWithStrength'

import UserContext from '@context/UserContext';

const Form = ({setShowRegister}) => {
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [error, setError] = useState("")

    const { register, setNewlyRegistered } = useContext(UserContext);

    const handleSubmit = async (e) => {
        // e.preventDefault();
        // setIsSubmitting(true);

        // const response = await register(firstName, lastName, email, password);

        // if (response?.errors?.length > 0) {
        //     setError(response?.errors?.[0]?.message);
        //     //alert(response.data.customerCreate.userErrors.map(error => error.message).join("\n"));
        // } else {
        //     if (response?.data?.customerCreate?.userErrors?.length > 0) {
        //         setError(response?.data?.customerCreate?.userErrors?.[0]?.message);
        //     } else {
        //         setNewlyRegistered(true);
        //         setShowRegister(false);
        //     }
        // }
        // setIsSubmitting(false);
    }

    const validateForm = () => {
        return (password.trim() === "" || confirmPassword.trim() === "") || password !== confirmPassword
	}

	return (
        <React.Fragment>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className={`flex flex-wrap gap-x-4 gap-y-3`}>
                    <InputPasswordWithStrength
                        id="regPassword"
                        label="Password"
                        password={password}
                        setPassword={setPassword}
                        showPassword={showPassword}
                        setShowPassword={setShowPassword}
                        className="flex-1 basis-full"
                        type={showPassword ? "text" : "password"}
                        placeholder="New password"
                        aria-label={"new password"}
                        enableShowPasswordIcon
                        labelOnTop
                    />

                    <InputField
                        id="confirmPassword"
                        showPassword={showConfirmPassword}
                        setShowPassword={setShowConfirmPassword}
                        label="Password"
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm new password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        aria-label={"confirm new password"}
                        enableShowPasswordIcon
                        labelOnTop
                    />
                </div>
                
                <button
                    type="submit"
                    className="w-full btn-primary mt-10"
                    disabled={validateForm() || isSubmitting}
                    aria-label="Register"
                >Change Password</button>
                {
                    error != "" ?
                        <div className="flex items-center p-4 mb-4 text-sm text-red-800 border border-red-300 rounded-lg bg-red-50  dark:text-red-400 dark:border-red-800" role="alert">
                            <svg className="shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                            </svg>
                            <span className="sr-only">Info</span>
                            <div>
                                <span className="font-medium">{error}</span> 
                            </div>
                        </div> : null
                }
            </form>
        </React.Fragment>
    )
}

export default Form;